import RegisterForm from "./registerForm.comp";

// #TODO
// - Recaptcha

// RegisterForm is self-contained: on success it routes the user to
// /auth/verifyMobileOtp to verify the SMS OTP sent at registration.
export default function RegisterPageForm() {
  return (
    <div className="w-full bg-guru-floral-white p-6 mb-8">
      <RegisterForm />
    </div>
  );
}
